module.exports = __webpack_public_path__ + "img/76_9.4ea238d0.png";